import { useState } from "react";
import { Tooltip, IconButton, Switch } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSelector, useDispatch } from "react-redux";
import { openModalMensualidad, targetBancoAction, eliminarBancoAction, obtenerBancosAllAction, actulizaBancoAction } from "../../../ducks/bancoDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import { ToastMessage } from "../../../global/ToastMessage";
import { yellow } from "@material-ui/core/colors";
const columns = [
    { id: "Nombre", minWidth: 150, align: "center", label: "Nombre" },
    { id: "Estatus", minWidth: 30, align: "center", label: "Estatus" },
    { id: "Accion", minWidth: 30, align: "center", label: "" },
];

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    container: {
        maxHeight: 440,
    },
});

const TBanco = () => {
    const classes = useStyles()
    const { bancos } = useSelector(store => store.banco)
    const dispatch = useDispatch()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const handleEdit = ({ banco }) => {
        dispatch(targetBancoAction({ banco, editar: true }))
    }
    const handleModalMensualidad = ({ banco }) => {
        dispatch(targetBancoAction({ banco, editar: false }))
        dispatch(openModalMensualidad({open: true}))
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    const handleChange = ({ banco }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(actulizaBancoAction({ idBanco: banco.IdBanco, Estatus: !banco.Estatus, Nombre: banco.Nombre, TasaCobro: 0 })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "error",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerBancosAllAction())
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    const handleEliminar = ({ banco }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(eliminarBancoAction({ idBanco: banco.IdBanco })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "error",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerBancosAllAction())
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bancos
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.IdBanco}>
                                        <TableCell align="center">{`${row.Nombre}`}</TableCell>
                                        <TableCell align="center">
                                            <label>
                                                {row.Estatus ? "Activo" : "Inactivo"}
                                            </label>
                                            <Switch
                                                checked={row.Estatus}
                                                onChange={() => handleChange({banco: row})}
                                                name={`checket-${row.IdBanco}`}
                                                inputProps={{ 'aria-label': 'checkbox' }}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <Tooltip title="Edutar">
                                                <IconButton
                                                    aria-label="Edutar"
                                                    onClick={() => { handleEdit({ banco: row }) }}
                                                >
                                                    <EditIcon style={{ color: yellow[400] }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Mensualidades">
                                                <IconButton
                                                    aria-label="Mensualidades"
                                                    onClick={() => { handleModalMensualidad({ banco: row }) }}
                                                >
                                                    <AccountBalanceIcon color="primary" />
                                                </IconButton>
                                            </Tooltip>
                                            {
                                                (false) && <Tooltip title="Eliminar">
                                                    <IconButton
                                                        aria-label="Eliminar"
                                                        onClick={() => { handleEliminar({ banco: row }) }}
                                                    >
                                                        <DeleteIcon color="error" />
                                                    </IconButton>
                                                </Tooltip>
                                            }

                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={bancos.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};
export default TBanco;
